import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import {
    DepartmentsServiceProxy,
    CreateOrEditDepartmentDto,
    DepartmentChartOfAccountLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditDepartmentModal',
    templateUrl: './create-or-edit-department-modal.component.html',
    standalone: false,
})
export class CreateOrEditDepartmentModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    department: CreateOrEditDepartmentDto = new CreateOrEditDepartmentDto();

    chartOfAccountDisplayProperty = '';
    chartOfAccountDisplayProperty2 = '';
    chartOfAccountDisplayProperty3 = '';
    chartOfAccountDisplayProperty4 = '';
    chartOfAccountDisplayProperty5 = '';

    allChartOfAccounts: DepartmentChartOfAccountLookupTableDto[];

    constructor(
        injector: Injector,
        private _departmentsServiceProxy: DepartmentsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(departmentId?: number): void {
        if (!departmentId) {
            this.department = new CreateOrEditDepartmentDto();
            this.department.id = departmentId;
            this.chartOfAccountDisplayProperty = '';
            this.chartOfAccountDisplayProperty2 = '';
            this.chartOfAccountDisplayProperty3 = '';
            this.chartOfAccountDisplayProperty4 = '';
            this.chartOfAccountDisplayProperty5 = '';

            this.active = true;
            this.modal.show();
        } else {
            this._departmentsServiceProxy.getDepartmentForEdit(departmentId).subscribe((result) => {
                this.department = result.department;

                this.chartOfAccountDisplayProperty = result.chartOfAccountDisplayProperty;
                this.chartOfAccountDisplayProperty2 = result.chartOfAccountDisplayProperty2;
                this.chartOfAccountDisplayProperty3 = result.chartOfAccountDisplayProperty3;
                this.chartOfAccountDisplayProperty4 = result.chartOfAccountDisplayProperty4;
                this.chartOfAccountDisplayProperty5 = result.chartOfAccountDisplayProperty5;

                this.active = true;
                this.modal.show();
            });
        }
        this._departmentsServiceProxy.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
        this._departmentsServiceProxy.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
        this._departmentsServiceProxy.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
        this._departmentsServiceProxy.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
        this._departmentsServiceProxy.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
    }

    save(): void {
        this.saving = true;

        this._departmentsServiceProxy
            .createOrEdit(this.department)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
